export default {
  open: {
    icon: '/static/grx/icons/licenses/open.svg',
    Title: 'IPU-OPEN: Свободный открытый доступ к объекту',
    Description: 'Смарт-контракт, предоставляющий доступ к объекту на условиях свободной открытой лицензии. При использовании объекта указывается уникальный номер депонирования объекта в распределенном реестре (код IPC). Ограничения: переработка объекта, использование в коммерческих целях.',
  },
  internal: {
    icon: '/static/grx/icons/licenses/internal.svg',
    Title: 'IPU-INTERNAL: Свободный открытый доступ к объекту для участников платформы IPUniversity',
    Description: 'Смарт-контракт, предоставляющий доступ к объекту на условиях свободной открытой лицензии для всех участников платформы IPUniversity (образовательные, научные, научно-образовательные организации).  При использовании объекта указывается уникальный номер депонирования объекта в распределенном реестре (код IPC).  Ограничения: передача объекта третьим лицам, его переработка, использование в коммерческих целях.',
  },
  org: {
    icon: '/static/grx/icons/licenses/org.svg',
    Title: 'IPU-ORG: Доступ в рамках организаций-правообладателей',
    Description: 'Смарт-контракт, предоставляющий доступ к объекту только представителям организаций-правообладателей объекта, которые также являются участниками платформы IPUniversity. При использовании объекта указывается уникальный номер депонирования объекта в распределенном реестре (код IPC). Ограничения: передача объекта представителям других организаций, третьим лицам, переработка объекта, использование в коммерческих целях.',
  },
  closed: {
    icon: '/static/grx/icons/licenses/closed.svg',
    Title: 'IPU-AUTHORS: Доступ только авторам – только депонирование',
    Description: 'Смарт-контракт, обеспечивающий доступ к объекту только авторам/соавторам объекта. Предназначен для простого депонирования объекта с последующим получением кода IPC. Обеспечивает условия для создания закрытых лицензий на доступ к объекту.',
  },
};



// WEBPACK FOOTER //
// ./src/data/licenses.js